export const gtagEvent = (name, params = {}) => {
  window.gtag('event', name, params);
};
